export const APPLICATION_NAME = 'gravity';
export const APPLICATION_VERSION = '0.0.1';
